import { useAccount } from '../plans/useAccount';
import { useEffect,useRef,useState } from 'react';
import { Modal,Button } from '../../components/ui';
import { PROVIDER_CREDIT_EVENT,providerNames,isProviderCreditIssue,type ProviderCreditIssue } from '../../lib/providerCredits';
export function ProviderCreditPopup() {
  const account=useAccount();
  const [issues,setIssues]=useState<ProviderCreditIssue[]>([]);
  const issue=issues[0]??null;
  const dismiss=()=>setIssues(previous=>previous.slice(1));
  const seen=useRef(new Set<string>());
  useEffect(()=>{
    const listener=(event:Event)=>{const {issue,key}=(event as CustomEvent).detail??{};if(!isProviderCreditIssue(issue))return;const id=key?`${issue.provider}:${key}`:null;if(id&&seen.current.has(id))return;if(id)seen.current.add(id);setIssues(previous=>previous.some(x=>x.provider===issue.provider)?previous:[...previous,issue]);};
    window.addEventListener(PROVIDER_CREDIT_EVENT,listener);return()=>window.removeEventListener(PROVIDER_CREDIT_EVENT,listener);
  },[]);
  if(account.data?.admin.active)return null;
  return <Modal open={!!issue} onOpenChange={open=>{if(!open)dismiss();}} title="A required service is out of credits" footer={<Button variant="primary" onClick={dismiss}>Got it</Button>}>
    <p>{issue?providerNames[issue.provider]:'The provider'} has run out of API credits, so Lumnos cannot complete the part of your request that needs this service.</p>
    <p><strong>Contact the site owner to refill credits.</strong> Once they refill the service, you can retry.</p>
    <p className="muted small">This is separate from your Lumnos credits. Upgrading your Lumnos plan will not refill the provider’s account.</p>
  </Modal>;
}
